export default "__VITE_ASSET__80TlU9Y6__"